import { useEffect, useState } from 'react';
import { clsx } from 'clsx';

const ANCHORS: ReadonlyArray<{ id: string; num: string; label: string }> = [
  { id: 'f1', num: '01', label: 'Ventes' },
  { id: 'f2', num: '02', label: 'Stock' },
  { id: 'f3', num: '03', label: 'Catalogue' },
  { id: 'f4', num: '04', label: 'Multi-boutique' },
  { id: 'f5', num: '05', label: 'Offline' },
  { id: 'f6', num: '06', label: 'Équipe' },
  { id: 'f7', num: '07', label: 'Rapports' },
  { id: 'f8', num: '08', label: 'Multi-plateforme' },
  { id: 'f9', num: '09', label: 'Velko Bar' },
  { id: 'f10', num: '10', label: 'Troc & reprise' },
  { id: 'f11', num: '11', label: 'Retours' },
  { id: 'f12', num: '12', label: 'Partenaires' },
];

export default function FeatureAnchorStripV2() {
  const [active, setActive] = useState<string>('f1');

  useEffect(() => {
    const sections = ANCHORS.map((a) => document.getElementById(a.id)).filter(
      (el): el is HTMLElement => el !== null,
    );
    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) setActive(visible.target.id);
      },
      { rootMargin: '-40% 0px -50% 0px', threshold: [0, 0.25, 0.5, 0.75, 1] },
    );
    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="sticky top-0 z-[60] border-b-2 border-charcoal-800 bg-white shadow-[0_4px_0_0_#1A1A2E]">
      <nav
        aria-label="Modules — navigation"
        className="mx-auto max-w-7xl overflow-x-auto px-6 md:px-8"
      >
        <ul className="flex min-w-max items-center gap-2 py-3 md:gap-1 md:py-4">
          {ANCHORS.map((a) => {
            const isActive = active === a.id;
            return (
              <li key={a.id}>
                <a
                  href={`#${a.id}`}
                  className={clsx(
                    'group inline-flex items-center gap-2 border-2 px-3 py-2 font-marketing-display text-[13px] font-semibold transition-all md:text-sm',
                    isActive
                      ? 'border-charcoal-800 bg-lime-500 text-charcoal-800 shadow-neobrutal-2'
                      : 'border-transparent bg-white text-charcoal-700 hover:border-charcoal-800 hover:bg-paper',
                  )}
                >
                  <span
                    className={clsx(
                      'font-marketing-mono text-[10px] font-medium uppercase tracking-[0.1em]',
                      isActive ? 'text-charcoal-800' : 'text-charcoal-400',
                    )}
                  >
                    {a.num}
                  </span>
                  {a.label}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
}
